// Copyright © Veeam Software Group GmbH

export enum STUB_PATHS {
  noMatch = 'noMatch',
}
